import CollectionGrid_1_1_5_33 from "./CollectionGrid_1_1_5_33"
import CollectionGrid_2_2_14 from "./CollectionGrid_2_2_14"
import CollectionGrid_2_2_14_round from "./CollectionGrid_2_2_14_round"
import CollectionGrid_2_2_25 from "./CollectionGrid_2_2_25"
import CollectionGrid_2_2_25_round from "./CollectionGrid_2_2_25_round"
import CollectionGrid_2_2_33 from "./CollectionGrid_2_2_33"
import CollectionGrid_2_2_33_round from "./CollectionGrid_2_2_33_round"
import CollectionGrid_2_2_50 from "./CollectionGrid_2_2_50"
import CollectionGrid_2_2_50_round from "./CollectionGrid_2_2_50_round"
export const CollectionGrid = {
    "CollectionGrid_1_1_5_33":CollectionGrid_1_1_5_33,
    "CollectionGrid_2_2_14":CollectionGrid_2_2_14,
    "CollectionGrid_2_2_14_round":CollectionGrid_2_2_14_round,
    "CollectionGrid_2_2_25":CollectionGrid_2_2_25,
    "CollectionGrid_2_2_25_round":CollectionGrid_2_2_25_round,
    "CollectionGrid_2_2_33":CollectionGrid_2_2_33,
    "CollectionGrid_2_2_33_round":CollectionGrid_2_2_33_round,
    "CollectionGrid_2_2_50":CollectionGrid_2_2_50,
    "CollectionGrid_2_2_50_round":CollectionGrid_2_2_50_round,
}